import Icon from '../../components/Icon'
import { formatCurrency } from '../../utils/format'

// Panel RESUMEN (.totals del diseño).
export default function TotalesPanel({ vm, submitting, onSubmit }) {
  const moneda = vm.comprobante.moneda
  const imp = (pct) => vm.impuestos.find((i) => i.tipoImpuesto?.porcentaje === pct)
  const fmt = (v) => formatCurrency(v || 0, moneda)

  return (
    <div className="totals">
      <div className="totals-head">
        <span>Resumen</span>
        <span className={'pill-tag ' + (vm.esContado ? 'contado' : 'credito')}>{vm.esContado ? 'Contado' : 'Crédito'}</span>
      </div>
      <div className="totals-body">
        <div className="total-row"><span className="lbl">Exenta</span><span className="val mono">{fmt(imp(0)?.total)}</span></div>
        <div className="total-row"><span className="lbl">Gravada 10%</span><span className="val mono">{fmt(imp(10)?.baseImponible)}</span></div>
        {imp(5) && <div className="total-row"><span className="lbl">Gravada 5%</span><span className="val mono">{fmt(imp(5)?.baseImponible)}</span></div>}
        <hr className="div" />
        <div className="total-row"><span className="lbl" style={{ fontSize: 11.5 }}>IVA 10%</span><span className="val mono" style={{ color: 'var(--text-muted)' }}>{fmt(imp(10)?.valor)}</span></div>
        <div className="total-row"><span className="lbl" style={{ fontSize: 11.5 }}>IVA 5%</span><span className="val mono" style={{ color: 'var(--text-muted)' }}>{fmt(imp(5)?.valor)}</span></div>
        <hr className="div" />
        <div className="total-row"><span className="lbl">Descuento global</span><span className="val mono">{fmt(0)}</span></div>
      </div>
      <div className="totals-grand">
        <span className="lbl">Total a pagar</span>
        <span className="val mono">{fmt(vm.totales.totalGeneral)}</span>
      </div>
      <div className="totals-actions">
        <button className="btn btn-primary btn-block" disabled={submitting} onClick={onSubmit}>
          {submitting ? 'Procesando…' : <><Icon name="check" size={15} /> Emitir factura <span className="kbd-inline">F10</span></>}
        </button>
        <button className="btn btn-block" disabled title="Próximamente"><Icon name="save" size={14} /> Guardar borrador</button>
      </div>
    </div>
  )
}
